module.exports = __webpack_public_path__ + "img/qrcode.564a2c4f.png";